import * as React from 'react';
import { OverflowContainer } from './OverflowContainer.js';
let ELLIPSIS_CHAR = '…';
export const MiddleTextTruncation = (props) => {
  let { text, style, ...rest } = props;
  return React.createElement(
    OverflowContainer,
    {
      as: 'span',
      style: {
        display: 'flex',
        minWidth: 0,
        flexGrow: 1,
        whiteSpace: 'nowrap',
        ...style,
      },
      itemsCount: text.length,
      ...rest,
    },
    React.createElement(MiddleTextTruncationContent, props),
  );
};
MiddleTextTruncation.displayName = 'MiddleTextTruncation';
let MiddleTextTruncationContent = (props) => {
  let { text, endCharsCount = 6, textRenderer } = props;
  let { visibleCount } = OverflowContainer.useContext();
  let truncatedText = React.useMemo(() => {
    if (visibleCount < text.length)
      return `${text.substring(
        0,
        visibleCount - endCharsCount - ELLIPSIS_CHAR.length,
      )}${ELLIPSIS_CHAR}${text.substring(text.length - endCharsCount)}`;
    return text;
  }, [endCharsCount, text, visibleCount]);
  return textRenderer?.(truncatedText, text) ?? truncatedText;
};
